// extracted by mini-css-extract-plugin
export default {"container":"subDetails_container__cSQ7-","items":"subDetails_items__CZobO","block":"subDetails_block__uaaHn","line":"subDetails_line__LdpxJ","btns":"subDetails_btns__t5E66"};